export class IFilterJobOffers{
    keyWord: string = "";
    department: number = 0;
    city: number = 0;
    typeContract: number = 0;
}